import React from 'react';
import TimeAgo from 'react-timeago';
import { Link } from 'react-router-dom';

export default ({ study, lastColumn, checked, onCheck, search }) =>
  <tr>
    {checked
      ? <td className="check">
          <input
            id="check-all"
            type="checkbox"
            name="all"
            checked={checked.find(item => item === study.id) || false}
            onChange={onCheck}
          />
        </td>
      : null}
    <td className="study">
      <Link
        to={{
          pathname: `/study/${study.id}/`,
          state: { study },
        }}
      >
        #{study.old_id || study.id}
      </Link>
    </td>
    <td className="patient">{study.patient_name}</td>
    <td className="company">{study.company.name}</td>
    <td className="scorer">
      {search
        ? study.search_time
        : lastColumn
          ? study.time_ago_stamp
            ? <TimeAgo date={new Date(study.time_ago_stamp * 1000)} />
            : null
          : study.scored_by ? study.scored_by.abbreviated_name : 'N/A'}
    </td>
  </tr>;



// WEBPACK FOOTER //
// ./src/views/shared/studies/item.js